module.exports = __webpack_public_path__ + "img/Speaker=Karly Hou.89ef03e0.png";